<kendo-toolbar [className]="'k-shadow'">
  <kendo-toolbar-button
    [className]="'d-xl-none'"
    [title]="'menu_topBar_toggle_title' | i18n"
    [icon]="'hamburger'"
    [toggleable]="true"
    (click)="toggleNav()"
  ></kendo-toolbar-button>
</kendo-toolbar>
